import { Component } from "@angular/core";

/** A single destination tile. Exactly one of routerLink / externalUrl is set. */
export interface LandingTile {
  title: string;
  description: string;
  ctaLabel: string;
  icon: string;
  accent: "blue" | "purple" | "amber" | "teal" | "green" | "red";
  routerLink?: string;
  externalUrl?: string;
}

@Component({
  standalone: false,
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["../styles.scss", "./landing.component.scss"],
})
export class LandingComponent {
  readonly pageTitle = "Azure Capacity, Access & Quota Portal";
  readonly pageSubtitle = "Please select your destination";

  readonly tiles: LandingTile[] = [
    {
      title: "Capacity Blueprints",
      description:
        "Declare capacity and quota demands as code for reserved capacity ahead of deterministic platform scenarios such as buildout and Availability Zone expansion.",
      ctaLabel: "Get Started",
      icon: "fa-drafting-compass",
      accent: "blue",
      externalUrl: "https://aka.ms/capacity-blueprint-wiki",
    },
    {
      title: "Planned Quota",
      description:
        "Declare blueprints and submit quota demands ahead of buildout or expansion for auto approved quota to your subscriptions.",
      ctaLabel: "Onboard Blueprints",
      icon: "fa-calendar-check",
      accent: "purple",
      routerLink: "/plans/all",
    },
    {
      title: "On Demand",
      description:
        "Request quota and access for immediate and one-off needs. Submit VM, SQL, Storage, Batch, App Service, and other tickets to Capacity team.",
      ctaLabel: "Make a request",
      icon: "fa-bolt",
      accent: "amber",
      routerLink: "/create-request",
    },
    {
      title: "Learn",
      description:
        "The Engineering Hub documents of Lionrock. Access onboarding processes, technical details, examples, and FAQs.",
      ctaLabel: "Start learning",
      icon: "fa-graduation-cap",
      accent: "teal",
      externalUrl: "https://aka.ms/lionrockwiki",
    },
    {
      title: "Self-Service",
      description:
        "Resolve common requests without filing a ticket. Check subscription status, manage authorized users, and access to information related to capacity, access, and quota.",
      ctaLabel: "Explore now",
      icon: "fa-user-cog",
      accent: "green",
      routerLink: "/self-service/region-information",
    },
    {
      title: "Get Help",
      description:
        "Connect with the Lionrock team. Join the Teams channel for support, office hours, announcements, and to ask questions directly to the Lionrock engineering team.",
      ctaLabel: "Join Teams channel",
      icon: "fa-comments",
      accent: "red",
      externalUrl: "https://aka.ms/lionrockhelp",
    },
  ];

  isExternal(tile: LandingTile): boolean {
    return !!tile.externalUrl;
  }
}
